<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-card class="change-reviewer">
    <v-subheader>
      <v-icon medium color="error" class="mr-2">people</v-icon>
      {{date}} <span class="ml-2">Отправлен запрос о смене ревьювера на уровне {{level}}</span>
    </v-subheader>
    <v-layout row>
      <v-flex>
        <v-card tile flat class="grey lighten-4">
          <v-card-text>
            <span class="font-weight-medium">Плохой ревьювер: </span>
            <UserCard :user="badReviewer"></UserCard>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
  import UserCard from "../user/UserCard";
  export default {
    name: "ChangeReviewerRequest",
    components: {UserCard},
    props: ["date", "description", "level", "badReviewer"]
  }
</script>

<style scoped>
  .change-reviewer {
    border: 1px solid #78909C;
  }
</style>